<app-summary-top i18n-name name="Role" [model$]="model$" [summaryItems]="summaryTopItems"></app-summary-top>

<app-tab
  [model]="model$ | async"
  [templates]="[
    { header: detailsHeader, template: details },
    { header: menusHeader, template: menuItems },
    { header: labelsHeader, template: documents },
  ]"
>
</app-tab>

<ng-template #details>
  <app-role-details (saved)="getModel()"></app-role-details>
</ng-template>

<ng-template #menuItems>
  <app-role-menu-items></app-role-menu-items>
</ng-template>

<ng-template #documents>
  <app-role-documents></app-role-documents>
</ng-template>
